module.exports = __webpack_public_path__ + "static/media/Group 2275.346796ba.svg";